import api from '../services/api';
import { createBaseModule } from './base';


export default createBaseModule( {
  state: {
    blog: [],
    noMoreBlog: false
  },
  mutations: {

  },
  actions: {
    async fetchBlog({ commit, state }, {page}) {
      if (page == 1)
        commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/blog/', {
          params: {
            page: page
          }
        });
        commit('SET_DATA', {data:response.data.data, page:page});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching blog:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    blog: state => state.data,
    blogLoading: state => state.loading,
    blogError: state => state.error,
    blogLoaded: state => state.loaded,
    noMoreBlog: state => state.noMoreBlog
  }
})